<template>
    <div>
        <div class="section">
            <h1 class="title is-uppercase">Pricelist Import</h1>
        </div>

        <div class="section" v-if="this.success">
            <b-notification type="is-success" has-icon>
                <p v-text="this.success"></p>
            </b-notification>
        </div>
        <div class="section" v-if="Object.keys(this.errors).length">
            <b-notification
                    v-if="Object.keys(this.errors).length"
                    type="is-danger"
                    has-icon>
                <ul v-for="(error, key) in errors" :key="'error-'+key">
                    <li v-for="(message, index) in error" :key="'error-message-'+index" v-text="message"></li>
                </ul>
            </b-notification>
        </div>

        <div id="brand-form" class="section">
            <div>
                <p class="has-text-weight-bold mt-4 mb-1">
                    {{__('strings.brand.form.upload_csv') }}
                </p>
                <b-field class="file is-primary">
                    <b-upload class="file-label"
                              v-model="input.file"
                              accept=".xls,.xlsx"
                              @input="(file)=>handleOnClickUploadCsv(file)">
                        <span class="file-cta">
                            <b-icon class="file-icon" icon="upload"></b-icon>
                            <span class="file-label">
                                {{__('strings.brand.form.click_to_upload_xls')}}
                            </span>
                        </span>
                        <span class="file-name" v-if="input.file && input.file.name">
                            {{ input.file.name }}
                        </span>
                    </b-upload>
                    <span v-if="input.file && input.file.name">
                        <b-button icon-right="close" @click="deleteMultiplierFileByIndexes()"/>
                    </span>
                </b-field>
            </div>
            <p class="has-text-weight-bold mt-4 mb-1">Retailer</p>
            <div class="">
                <b-field>
                    <b-select :placeholder="__('strings.discount.select')" v-model="input.retailer_id" expanded>
                        <option v-for="retailer in retailers" :value="retailer.id" :key="retailer.id+retailer.name">
                            {{ retailer.name }}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </div>
        <footer class="modal-card-foot is-justify-content-flex-start">
            <div class="buttons">
                <b-button type="is-primary" @click="upload">Upload</b-button>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                input: {
                    name: null,
                    file: null,
                    retailer_id: null,
                },
                retailersMap: new Map(),
                retailers: [{id: 1, name: 'SamGP+FL'}, {id: 2, name: 'SamGG'}],
                errors: {},
                success: null,
                sended: {
                    message: ''
                },
            };
        },
        beforeMount() {
            axios.get('retailer/index?paginate=false')
                .then(response => {
                    this.retailers = response.data;
                })
                .catch(error => {});
        },
        mounted() {
        },
        methods: {
            upload() {
                this.loading = true;
                let formData = new FormData;
                for (let [key, value] of Object.entries(this.input)) {
                    formData.append(key, value);
                }

                axios.post('/product/pricelist/upload', formData)
                    .then(response => (this.success = response.data))
                    .catch(error => {
                        if (error.response.data.errors) {
                            return this.errors = error.response.data.errors;
                        } else {
                            return this.errors = [[error.message]];
                        }
                    })
                    .finally(() => this.loading = false)
            },
            createMapByArrayWithId(array) {
                const map = new Map();
                array?.forEach(item => {
                    map.set(item?.id, item);
                });
                return map;
            },
            convertWebsitesData(relationships) {},
            handleOnClickUploadCsv(file) {
                this.input.file = file;
                this.input.name = this.input.file?.name;
                this.$set(this.input, 'file', this.input.file);
            },
            deleteMultiplierFileByIndexes() {
                this.input.file = null;
                this.$set(this.input, 'file', this.input.file);
            },
            deleteCsvFileByIndex(index) {
                // this.input.files.splice(index, 1);
            }
        },
        computed: {
            title() {
                let translationKey = this.item ? 'strings.brand.form.editTitle' : 'strings.brand.form.title';
                return this.__(translationKey);
            }
        }
    };
</script>
